import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

const SendFromWarningModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.sendFromWarningModalVisible}
        onClose={distributeStore.hideSendFromWarningModal}
    >
        <div className="delete-modal-content">
            <i className="fal fa-circle-exclamation" style={{ fontSize: 36, color: 'red' }} />

            <h2>{i18n.t('distributionSendFromWarning.title')}</h2>

            <h4>{i18n.t('distributionSendFromWarning.subtitle')}</h4>
        </div>

        <ModalFooter>
            <Button cssClass="regular tertiary" onClick={distributeStore.hideSendFromWarningModal}>
                {i18n.t('close')}
            </Button>
        </ModalFooter>
    </Modal>
)

export default observer(SendFromWarningModal)
